<template>
  <div class="watchCenterPage">
    <leftNav :navarr="navarr" />
    <div class="main-center">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import leftNav from "../../components/leftNav";

export default {
  name: "watchCenterPage",
  data() {
    return {
      navarr: [
        { name: "用户管理", icon: require("@/assets/leftnav/user.png") },
        { name: "角色管理", icon: require("@/assets/leftnav/role.png") },
        { name: "组织管理", icon: require("@/assets/leftnav/org.png") },
        { name: "隐患配置", icon: require("@/assets/leftnav/hiddle.png") },
        { name: "短信配置", icon: require("@/assets/leftnav/note.png") },
        { name: "推送配置", icon: require("@/assets/leftnav/user.png") },
        { name: "标签管理", icon: require("@/assets/leftnav/tag.png") },
        { name: "日志管理", icon: require("@/assets/leftnav/log.png") },
        { name: "应用管理", icon: require("@/assets/leftnav/org.png") },
        { name: "合作方管理", icon: require("@/assets/leftnav/role.png") },
        { name: "隐患管理", icon: require("@/assets/leftnav/org.png") },
        // { name: "租户管理", icon: require("@/assets/leftnav/role.png") },
      ],
    };
  },
  methods: {},
  mounted() {},
  watch: {},
  components: {
    leftNav,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.watchCenterPage {
  height: 100%;
  overflow: auto;
}
.main-center {
  width: calc(100% - 240px);
  height: 100%;
  display: inline-block;
  vertical-align: top;
  background-color: #ecf0f6;
  padding: 20px 24px;
  overflow: auto;
}
</style>
